import clsx from "clsx";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
import HighlightTeaser from "../molecules/HighlightTeaser";
import Teaser from "../molecules/Teaser";
export default function FeaturedResources(props) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !!props.teasers.length && /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:px-14 relative overflow-hidden", {
            "bg-gray-10 pt-12 md:pt-20 pb-12 md:pb-20": props.bgColor === "grey",
            "mt-12 md:mt-28 lg:mt-16 pb-16 md:pb-24 lg:pb-28": props.bgColor !== "grey"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative z-10 text-center lg:text-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "text-center md:mb-16": props.isHeader === true
        })
    }, props.isHeader === true ? /*#__PURE__*/ React.createElement("h1", {
        className: "text-[2rem] leading-tight md:text-5xl lg:text-6xl lg:leading-tight font-heading font-semibold"
    }, props.heading) : /*#__PURE__*/ React.createElement("h2", {
        className: clsx("font-heading text-2xl md:text-4xl", {
            "mb-0.5 md:mb-2": props.subheading,
            "mb-9 md:mb-16": !props.subheading
        })
    }, props.heading), props.subheading ? /*#__PURE__*/ React.createElement("p", {
        className: clsx("text-sm md:text-base text-gray-200 mb-10 md:mb-14", {
            "text-lg lg:text-xl mt-3.5": props.isHeader === true
        })
    }, props.subheading) : null), /*#__PURE__*/ React.createElement("div", {
        className: clsx("lg:flex text-left", {
            "lg:gap-x-32 xl:gap-x-48": props.isHeader !== true,
            "lg:gap-x-12": props.isHeader === true
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mb-12 md:mb-16 lg:mb-0 lg:w-7/12", {
            "lg:w-7/12": props.isHeader !== true,
            "lg:w-1/2": props.isHeader === true
        })
    }, !!props.teasers.length && props.teasers[0] ? /*#__PURE__*/ React.createElement(HighlightTeaser, props.teasers[0]) : null), /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "lg:w-5/12": props.isHeader !== true,
            "lg:w-1/2": props.isHeader === true
        })
    }, /*#__PURE__*/ React.createElement("div", null, !!props.teasers.length && props.teasers.length > 1 && props.teasers.slice(1).filter(isTruthy).map(function(teaser, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: clsx("border-b border-b-gray-400 pb-8 md:pb-10 mb-10 last:pb-0", {
                "last:pb-8 lg:last:mb-0 lg:last:border-none": props.moreLink,
                "lg:last:pb-0 last:border-none last:mb-0": !props.moreLink
            })
        }, /*#__PURE__*/ React.createElement(Teaser, teaser));
    })), props.moreLink ? /*#__PURE__*/ React.createElement("a", {
        href: "".concat(props.moreLink),
        className: "flex focus items-center text-sm font-heading font-semibold group md:ml-7"
    }, props.moreLinkTitle, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 31 30",
        version: "1.1",
        className: "h-3.5 w-3.5 ml-1.5 relative left-0 transition-all group-hover:left-1 text-black group-hover:text-blue-500"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-638.000000, -6605.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Resources",
        transform: "translate(0.000000, 6046.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(0.000000, 130.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Resource-Tile/Featured",
        transform: "translate(73.000000, 14.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link/Arrow-Block",
        transform: "translate(550.000000, 400.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Arrow/Small",
        transform: "translate(15.000000, 15.000000)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "30",
        height: "30"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18.1066017,4.39339828 L28.7132034,15 L18.1066017,25.6066017 M28.7132034,15 L1.71320344,15",
        id: "Icon",
        stroke: "currentColor",
        strokeWidth: "2.5"
    })))))))))) : null))), props.bgColor !== "grey" ? /*#__PURE__*/ React.createElement("svg", {
        width: "871px",
        height: "500px",
        viewBox: "0 0 871 500",
        version: "1.1",
        className: "hidden md:block absolute top-0 lg:top-[unset] lg:bottom-0 -left-96 lg:-left-20"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(0.000000, -6270.000000)",
        fill: "#F7F9FB"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Resources",
        transform: "translate(0.000000, 6046.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(0.000000, 130.000000)"
    }, /*#__PURE__*/ React.createElement("polygon", {
        id: "Gray-Cutout-Panel",
        transform: "translate(435.500000, 344.000000) scale(-1, 1) translate(-435.500000, -344.000000) ",
        points: "2.23430866e-13 437.01676 355.306214 94 871 94 871 594 3.86801702e-13 594"
    })))))) : null));
}
